import type { FormEvent, ReactNode } from 'react';

interface FilterBarProps {
  onSubmit: () => void;
  onReset?: () => void;
  /** 필터 입력 요소들 */
  children: ReactNode;
  submitLabel?: string;
  resetLabel?: string;
}

/**
 * 검색·필터 바
 * - children 으로 필터 필드들 전달 (Input/Select 컴포넌트 권장)
 * - 모바일: 세로 스택 / md 이상: 가로 정렬
 */
export function FilterBar({
  onSubmit,
  onReset,
  children,
  submitLabel = '검색',
  resetLabel = '초기화',
}: FilterBarProps) {
  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="rounded-lg border border-gray-200 bg-white p-3"
    >
      <div className="flex flex-col gap-2 md:flex-row md:flex-wrap md:items-center">
        {children}
        <div className="flex gap-2 md:ml-auto">
          <button
            type="submit"
            className="flex-1 whitespace-nowrap rounded-lg bg-primary-500 px-5 py-1.5 text-sm font-medium text-white transition-colors hover:bg-primary-600 md:flex-none"
          >
            {submitLabel}
          </button>
          {onReset && (
            <button
              type="button"
              onClick={onReset}
              className="flex-1 whitespace-nowrap rounded-lg bg-gray-200 px-5 py-1.5 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-300 md:flex-none"
            >
              {resetLabel}
            </button>
          )}
        </div>
      </div>
    </form>
  );
}

interface FilterFieldProps {
  label?: string;
  className?: string;
  children: ReactNode;
  /** flex 영역에서 차지하는 비중 (기본 'flex-1') */
  flex?: 'flex-1' | 'flex-none';
}

/**
 * 필터 필드 래퍼 (라벨 + 입력)
 */
export function FilterField({
  label,
  className = '',
  children,
  flex = 'flex-1',
}: FilterFieldProps) {
  return (
    <div className={`${flex} min-w-0 ${className}`}>
      {label && (
        <label className="mb-1 block text-xs font-medium text-gray-600">
          {label}
        </label>
      )}
      {children}
    </div>
  );
}
